class firm {
    constructor(
      id,
      name,
      order

      ) {
      this.id = id;
      this.name = name;
      this.order = order;
    }
    static fromJson({
    
        reglaLiqId,
        nombre,
        orden
    }) {
      return new firm(
        reglaLiqId,
        nombre,
        orden

      );
    }
  }
  export default firm;
  